import React, { Component } from 'react';
import HandDraw from './HandDraw';
import DrawResult from './DrawResult';
import EditData from './EditData';
import ExampleSelect from './ExampleSelect';
class Main extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: "example"
		}
	}

	setPoints = (points, edit_points = undefined, normalize_margin = 0.95) => {
		this.setState({
			points: points,
			normalize_margin: normalize_margin
		});
		if (edit_points) {
			this.setState({ edit_points: edit_points });
		}
	}

	setMode(mode) {
		this.setState({
			mode: mode
		});
	}
	render() {
		const buttonstyle = {
			fontSize: "150%",
			borderRadius: "10px",
			margin: "0 2px"
		};
		const buttonselected = {
			background: "yellow"
		};

		return (
			<div>
				<h1>Fourier series</h1>
				<div class='topright'>
					<button
						onClick={() => window.location = "/"}
						style={buttonstyle}
					>
						Kjell's homepage
					</button>
				</div>
				<button
					onClick={() => this.setMode("example")}
					style={this.state.mode === "example" ? { ...buttonstyle, ...buttonselected } : buttonstyle}
				>
					Fourier main
				</button>
				<button
					onClick={() => this.setMode("draw")}
					style={this.state.mode === "draw" ? { ...buttonstyle, ...buttonselected } : buttonstyle}
				>
					Draw image
				</button>
				<button
					onClick={() => this.setMode("edit")}
					style={this.state.mode === "edit" ? { ...buttonstyle, ...buttonselected } : buttonstyle}
				>
					Edit data
				</button>
				{this.state.points?.length && <button
					onClick={() => this.setMode("view")}
					style={this.state.mode === "view" ? { ...buttonstyle, ...buttonselected } : buttonstyle}
				>
					View result
				</button>}
				<br />
				{
					this.state.mode === "draw" &&
					<HandDraw
						setPointsCallback={this.setPoints}
						setMode={(mode) => this.setMode(mode)}
					/>
				}
				{
					this.state.mode === "view" &&
					<DrawResult
						points={this.state.points}
						normalize_margin={this.state.normalize_margin}
					/>
				}
				{
					this.state.mode === "edit" &&
					<EditData
						points={this.state.edit_points}
						setPointsCallback={this.setPoints}
						setMode={(mode) => this.setMode(mode)}
					/>
				}
				{
					this.state.mode === "example" &&
					<ExampleSelect
						setPointsCallback={this.setPoints}
						setMode={(mode) => this.setMode(mode)}
					/>
				}
			</div>
		);
	}
}

export default Main;